import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { DataProvider } from './context/DataContext';

// 日本語版コンポーネント
import LandingPage from './components/LandingPage';
import AppContent from './components/AppContent';

// 英語版コンポーネント
import EnLandingPage from './components/en/LandingPage';
import EnAppContent from './components/en/AppContent';

// テーマ設定（ブランド基盤）
const theme = createTheme({
  palette: {
    primary: {
      main: '#4f46e5', // Primary
    },
    secondary: {
      main: '#7e22ce', // Secondary
    },
    success: {
      main: '#22c55e',
    },
    warning: {
      main: '#f59e0b',
    },
    error: {
      main: '#ef4444',
    },
    text: {
      primary: '#0f172a', // 主
      secondary: '#334155', // 副
    },
    background: {
      default: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
    h5: {
      fontWeight: 500,
    },
  },
  // 任意のカスタムトークン
  custom: {
    mutedText: '#94a3b8', // ミュート
    gradient: 'linear-gradient(to right, #4f46e5, #7e22ce)', // ブランドグラデ
  },
});

// アプリケーションラッパーコンポーネント
function App() {
  const [language, setLanguage] = useState('ja'); // デフォルトは日本語

  // 言語に応じてコンポーネントを選択
  const LandingComponent = language === 'ja' ? LandingPage : EnLandingPage;
  const AppContentComponent = language === 'ja' ? AppContent : EnAppContent;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route 
            path="/" 
            element={<LandingComponent onLanguageChange={setLanguage} />} 
          />
          <Route 
            path="/app" 
            element={
              <DataProvider>
                <AppContentComponent onLanguageChange={setLanguage} />
              </DataProvider>
            } 
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
